import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PUBLIC_URL = typeof window !== "undefined" ? window.location.origin : "";
export const COVER_IMAGE = "/cover.jpg";

export const AUTHOR = {
  name: "Chris LaFreniere",
  book: "Bipolar Is Who I Am",
  blurb:
    "Bipolar Is Who I Am is my candid memoir of life with bipolar I disorder—from delusions and psychiatric wards to faith, recovery, and the extraordinary gift of an ordinary life.",
};

export function errorText(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace("Value error, ", "")).join(" ");
  return "Something went wrong. Please try again.";
}

export function adminClient() {
  const token = localStorage.getItem("ek_admin_token");
  return axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} });
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export const money = (n) => `$${Number(n ?? 0).toFixed(Number(n) % 1 ? 2 : 0)}`;
